import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next'; // Use the translation hook
import MachineDropdown from './MachineDropdown';
import TechnicianDropdown from './TechnicianDropdown';
import { ApiBaseUrlContext } from '../App';
import Modal from 'react-modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { formatDateByLocale } from '../utils/dateUtils';
import '../boxitem.css';
import '../Button.css';
import '../forms.css';
import '../filter.css';
import '../topmenu.css';
import './ServiceReport.css';
import { ReactComponent as FilterIcon } from '../assets/svg/icon-filter.svg';
import { ReactComponent as AddIcon } from '../assets/svg/icon-add.svg';
import { ReactComponent as SectionToggleArrow } from '../assets/svg/icon-toggle-section-arrow.svg';
import { ReactComponent as RemoveItemIcon } from '../assets/svg/icon-remove-1.svg';
import { ReactComponent as FileIcon } from '../assets/svg/icon-file-16.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import BoxItem from './BoxItem'; // deprecated
import '../table-list-2.css';
import GroupedDataTable from './GroupDataTable2'; 
import {jwtDecode} from 'jwt-decode';  // Corrected the import of jwt-decode
Modal.setAppElement('#root');

const ServiceReport = ({ onAddReport }) => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [machineGroups, setMachineGroups] = useState([]);
  const [selectedMachineGroup, setSelectedMachineGroup] = useState('');
  const [showFilters, setShowFilters] = useState(false); // Toggle filters visibility
  const [showContent, setShowContent] = useState(true);
  const [selectedTechnician, setSelectedTechnician] = useState('');
  const [faults, setFaults] = useState([]);
  const location = useLocation();
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedFault, setSelectedFault] = useState('');
  const [newFault, setNewFault] = useState('');
  const [hourlyRate, setHourlyRate] = useState(0.00); 
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [currencyPosition, setCurrencyPosition] = useState('right');
  const [technicianEntries, setTechnicianEntries] = useState([{ technician: '', times: [{ startTime: new Date(), endTime: new Date(), description: '', hourly_rate: hourlyRate, external: false, isNew: true }] }]);
  const [descriptionAction, setDescriptionAction] = useState('');
  const [materials, setMaterials] = useState([{ quantity: '', description: '', price: '', unit: '' }]);
  const [files, setFiles] = useState([]);
  const [faultFiles, setFaultFiles] = useState([]);
  const [totalCost, setTotalCost] = useState(0);
  const [serviceReports, setServiceReports] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [status, setStatus] = useState('New');
  const [editableField, setEditableField] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [setReportToDelete] = useState(null);
  const [timezone, setTimezone] = useState('UTC');
  const [errorMessage, setErrorMessage] = useState('');
  const [isFromFault, setIsFromFault] = useState(false); 
  const [selectedFaultId, setSelectedFaultId] = useState(null);
  const [temporaryFaults, setTemporaryFaults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const { t, i18n } = useTranslation(); // Using translation hook
  const [permissions, setPermissions] = useState({ can_edit: false, can_delete: false ,can_view: true }); // Default to view only
  const [activeTimeIndex, setActiveTimeIndex] = useState(null); // For time entries
  const [activeMaterialIndex, setActiveMaterialIndex] = useState(null); // For material entries

  console.log('apiBaseUrl:', apiBaseUrl);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      // Fetch user permissions based on role
      const fetchPermissions = async () => {
        try {
          const response = await axios.get(`${apiBaseUrl}/mnt/api/roles/permissions/${decodedToken.user_rights}`);
          console.log('Fetched permissions:', response.data); // Log fetched permissions
          setPermissions({
            can_edit: response.data.some(permission => permission.permission_name === 'can_edit' && permission.can_edit === 1),
            can_view: response.data.some(permission => permission.permission_name === 'can_view' && permission.can_view === 1),
            can_delete: response.data.some(permission => permission.permission_name === 'can_delete' && permission.can_delete === 1)
          });
        } catch (error) {
          console.error('Error fetching permissions:', error);
        }
      };

      fetchPermissions();
    }
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/settings`);
        const settings = response.data;
        
        setCurrencySymbol(settings.currencySymbol || 'kr'); // Set currency symbol
        setCurrencyPosition(settings.currencyPosition || 'right'); // Set position
        // ... other settings
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
  
    fetchSettings();
  }, [apiBaseUrl]);
  useEffect(() => {
    // Add event listener for paste functionality
    const handlePaste = (event) => {
      const clipboardItems = event.clipboardData.items;
      for (let item of clipboardItems) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) {
            setFiles((prevFiles) => [...prevFiles, file]);
          }
        }
      }
    };

    window.addEventListener('paste', handlePaste);

    return () => {
      window.removeEventListener('paste', handlePaste);
    };
  });

  const formatDateTimeForDatabase = (datetime) => {
    return moment.tz(datetime, timezone).valueOf();
  };

  const handleEditReport = useCallback(async (report) => {
    window.scrollTo(0, 0);
    try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/service-reports/${report.servicereportid}`, {
            headers: {
                'Accept': 'application/json'
            }
        });

        const { report: reportDetails, technicians, timeEntries, materials, files } = response.data;
        const machineid = reportDetails.machine;
        const response2 = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
          params: { machineid},
          headers: {
            'Accept': 'application/json'
          }
        });
        const fault = response2.data;
        console.log('Service Report Fault ID:', reportDetails.faultID);
console.log(fault);
const faultRecord = Object.values(fault).find(f => f.id === reportDetails.faultID);

        console.log('Matched Fault Record:', faultRecord);
        let faultFiles = [];
        if (faultRecord && faultRecord.files) {
          try {
            const parsed = typeof faultRecord.files === 'string'
              ? JSON.parse(faultRecord.files)
              : faultRecord.files;
            // Flatten in case it's nested:
            let flatFiles = Array.isArray(parsed) ? parsed.flat() : [];
            // Map each file so that it has a 'filepath' property:
            flatFiles = flatFiles.map(file => ({
              ...file,
              filepath: file.filepath || file.path || ''
            }));
            faultFiles = flatFiles;
          } catch (error) {
            console.error('Error parsing fault files:', error);
          }
        }
        setFaultFiles(faultFiles);
        setSelectedMachine({ machine: reportDetails.machine, machineid: reportDetails.machineid });
        setSelectedFault(reportDetails.fault);
        setDescriptionAction(reportDetails.description_action);
        setIsEditing(true);
        setEditId(reportDetails.servicereportid);
        setStatus(reportDetails.status);
        const technicianEntries = technicians.map((technician) => ({
          ...technician,
          times: timeEntries
              .filter((time) => time.techentryid === technician.techentryid)
              .map((time) => {
                  const startTime = time.start_time ? new Date(time.start_time) : new Date();
                  const endTime = time.end_time ? new Date(time.end_time) : new Date();
                  return {
                      startTime: isNaN(startTime) ? new Date() : roundToNearest15(startTime),
                      endTime: isNaN(endTime) ? new Date() : roundToNearest15(endTime),
                      description: time.timedescription,
                      hourly_rate: time.hourly_rate,
                      external: time.external,
                  };
              })
      }));

        setTechnicianEntries(technicianEntries);
        setMaterials(materials);
        setFiles(files);
        setShowForm(true);
        setShowContent(false);
    } catch (error) {
        console.error('Error fetching service report details:', error);
    }
}, [apiBaseUrl]);




  

useEffect(() => {
  const fetchData = async () => {
    const savedTimezone = localStorage.getItem('timezone');
    if (savedTimezone) {
        setTimezone(savedTimezone);
    }
    const faultFromState = location.state?.fault;
    const serviceReportId = location.state?.serviceReportId;

    if (faultFromState) {
        setEditId(serviceReportId);
        setSelectedMachine({ machine: faultFromState.machine, machineid: faultFromState.machineid });
        setSelectedFault(faultFromState.description);
        setSelectedFaultId(faultFromState.id);
        
        if (faultFromState.technician === '') {
            setTechnicianEntries([{ technician: '', times: [{ startTime: roundToNearest15(new Date()), endTime: roundToNearest15(new Date()), description: '', isNew: true }] }]);
        } else {
            setTechnicianEntries([{
                technician: faultFromState.technician,
                times: [{ startTime: roundToNearest15(new Date()), endTime: roundToNearest15(new Date()), description: '', isNew: true }]
            }]);
        }
        const machineid2 = faultFromState.machineid;
        try {
            const response2 = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
              params: { machineid2 },
              headers: { 'Accept': 'application/json' }
            });
            const faultData = response2.data;
            console.log('Service Report Fault ID:', faultData.id);
            console.log(faultData);
            const faultRecord = Object.values(faultData).find(f => f.id === faultFromState.id);


            console.log('Matched Fault Record:', faultRecord);
            let faultFiles = [];
            if (faultRecord && faultRecord.files) {
              try {
                const parsed = typeof faultRecord.files === 'string'
                  ? JSON.parse(faultRecord.files)
                  : faultRecord.files;
                let flatFiles = Array.isArray(parsed) ? parsed.flat() : [];
                flatFiles = flatFiles.map(file => ({
                  ...file,
                  filepath: file.filepath || file.path || ''
                }));
                faultFiles = flatFiles;
              } catch (error) {
                console.error('Error parsing fault files:', error);
              }
            }
            setFaultFiles(faultFiles);
            setIsFromFault(true);
            setShowForm(true);
            setShowContent(false);

            if (serviceReportId) {
                handleEditReport({ servicereportid: serviceReportId, fault: faultFromState.description, machine: faultFromState.machine });
            }
        } catch (error) {
            console.error('Error fetching fault errors:', error);
        }
    }
  };
  fetchData();
}, [location.state, handleEditReport]);

  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      if (editId) {
        navigator.sendBeacon(`${apiBaseUrl}/mnt/api/service-reports/${editId}/temp-delete`, {});
        console.log('Attempting to delete temp service report on page unload:', editId);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [editId, apiBaseUrl]);

  useEffect(() => {
    const fetchHourlyRate = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/settings`);
        const settings = response.data;
        setHourlyRate(parseFloat(settings.hourlyRate || 0.00));
      } catch (error) {
        console.error('Error fetching hourly rate:', error);
      }
    };

    fetchHourlyRate();
  }, [apiBaseUrl]);

  useEffect(() => {
    return () => {
      if (editId) {
        axios.post(`${apiBaseUrl}/mnt/api/service-reports/${editId}/temp-delete`)
          .then(() => {
            console.log('Temporary service report deleted on page leave:', editId);
          })
          .catch(err => {
            console.error('Error deleting temporary service report on page leave:', err);
          });
      }
    };
  }, [editId, apiBaseUrl]);

  useEffect(() => {
    const calculateTotalCost = () => {
      const total = materials.reduce((sum, material) => {
        const quantity = parseFloat(material.quantity) || 0;
        const price = parseFloat(material.price) || 0;
        return sum + (quantity * price);
      }, 0);
      setTotalCost(total);
    };
  
    calculateTotalCost();
  }, [materials]);

  const fetchMachineGroups = useCallback(async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/groups`);
      setMachineGroups(response.data);
    } catch (error) {
      console.error('Error fetching machine groups:', error);
    }
  }, [apiBaseUrl]);

  const fetchFaultsForMachine = useCallback(async (machine) => {
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
        params: { machine },
        headers: {
          'Accept': 'application/json'
        }
      });
      setFaults(response.data);
    } catch (error) {
      console.error('Error fetching faults for machine:', error);
    }
  }, [apiBaseUrl]);

  const fetchServiceReports = useCallback(async () => {
    let machineDB = '';
    if(selectedMachine){
      machineDB = selectedMachine.machine;
    }
    try {
      const token = localStorage.getItem('token');
      //console.log(selectedMachine);
      const response = await axios.get(`${apiBaseUrl}/mnt/api/service-reports`, {
        params: {
          machine: machineDB,
          machineGroup: selectedMachineGroup,
          technician: selectedTechnician,
        },
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,  // Send token in the Authorization header
        },
      });
      
      console.log('API response:', response.data);
      setServiceReports(response.data);
    } catch (error) {
      console.error('Error fetching service reports:', error);
    }
  }, [apiBaseUrl, selectedMachine, selectedMachineGroup, selectedTechnician]);
  
  useEffect(() => {
    fetchMachineGroups();
    fetchServiceReports();
  }, [fetchMachineGroups, fetchServiceReports]);

  useEffect(() => {
    const savedTimezone = localStorage.getItem('timezone');
    if (savedTimezone) {
      setTimezone(savedTimezone);
    }
    if (selectedMachine) {
      fetchFaultsForMachine(selectedMachine.machine);
    }

    fetchServiceReports();
  }, [selectedMachine, fetchFaultsForMachine, fetchServiceReports, apiBaseUrl]);

  const handleAddFault = () => {
    if (selectedMachine && newFault.trim() !== '') {
      const newFaultEntry = {
        description: newFault,
        status: 'New',
        id: Date.now(),
        isTemporary: true,
      };

      setFaults((prev) => [...prev, newFaultEntry]);
      setTemporaryFaults((prev) => [...prev, newFaultEntry]);
      setSelectedFault(newFault);
      setSelectedFaultId(newFaultEntry.id);
      setNewFault('');
    }
  };

  const handleMaterialChange = (index, field, value) => {
    const newMaterials = [...materials];
    newMaterials[index][field] = value;
    setMaterials(newMaterials);
  };

  const handleAddMaterial = () => {
    setMaterials([...materials, { quantity: '', description: '', price: '', unit: '' }]);
  };

  const handleRemoveMaterial = (index) => {
    if(materials.length > 1){
      const newMaterials = materials.filter((_, i) => i !== index);
      setMaterials(newMaterials);
    }
  };

  const handleFileChange = (e) => {
    setFiles([...files, ...Array.from(e.target.files)]);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };
  const handleTechnicianChange = (index, technician) => {
    const newEntries = [...technicianEntries];
  
															   
  
																 
    newEntries[index].technician = technician.name;
    newEntries[index].external = technician.external;
  
    newEntries[index].times.forEach((time) => {
      time.hourly_rate = technician.hourly_rate || hourlyRate;
      time.external = technician.external;
    });
  
																		
  
    setTechnicianEntries(newEntries);
  };

  const handleTechnicianChangeFilter = (index, technician) => {
    const newEntries = [...technicianEntries];
  
															   
  
																 
    newEntries[index].technician = technician.name;
    newEntries[index].external = technician.external;
    setSelectedTechnician(technician.name); 
												  
    newEntries[index].times.forEach((time) => {
      time.hourly_rate = technician.hourly_rate || hourlyRate;
      time.external = technician.external;
    });
  
																		
  
    setTechnicianEntries(newEntries);
  };

  const handleAddTechnician = () => {
    setTechnicianEntries([...technicianEntries, { technician: '', times: [{ startTime: roundToNearest15(new Date()), endTime: roundToNearest15(new Date()), description: '', isNew: true }] }]);
  };

  const handleRemoveTechnician = (index) => {
    if (technicianEntries.length > 1) {
      const newEntries = technicianEntries.filter((_, i) => i !== index);
      setTechnicianEntries(newEntries);
    }
  };

  const handleAddTimeEntry = (techIndex) => {
    const nowInTimezone = moment.tz(new Date(), timezone).toDate(); // Default to current time in selected timezone
    const newEntries = [...technicianEntries];
    console.log(newEntries[techIndex].times);
    newEntries[techIndex].times.push({
      startTime: roundToNearest15(nowInTimezone),
      endTime: roundToNearest15(nowInTimezone),
      description: '',
      hourly_rate: newEntries[techIndex].times[0].hourly_rate || hourlyRate,
      external: newEntries[techIndex].external,
      isNew: true
    });

    setTechnicianEntries(newEntries);
  };
  const handleTimeEntryChange = (techIndex, timeIndex, field, value) => {
    const newEntries = [...technicianEntries];
  
    // Convert user input to a local Date (via moment/timezone)
    const selectedDate = moment.tz(value, timezone).toDate();
  
    // 1) Round it before storing:
    const roundedDate = roundToNearest15(selectedDate);
  
    if (field === 'startTime') {
      newEntries[techIndex].times[timeIndex].startTime = roundedDate;
  
      // If start > end, sync them
      if (
        newEntries[techIndex].times[timeIndex].endTime &&
        newEntries[techIndex].times[timeIndex].endTime < roundedDate
      ) {
        newEntries[techIndex].times[timeIndex].endTime = roundedDate;
      }
    } else if (field === 'endTime') {
      newEntries[techIndex].times[timeIndex].endTime = roundedDate;
  
      // If end < start, sync them
      if (
        newEntries[techIndex].times[timeIndex].startTime &&
        newEntries[techIndex].times[timeIndex].startTime > roundedDate
      ) {
        newEntries[techIndex].times[timeIndex].startTime = roundedDate;
      }
    } else {
      // For other fields, no rounding
      newEntries[techIndex].times[timeIndex][field] = value;
    }
  
    setTechnicianEntries(newEntries);
  };
           
  const handleRemoveTimeEntry = (techIndex, timeIndex) => {

    const newEntries = [...technicianEntries];

    if (newEntries[techIndex].times.length > 1) {

      newEntries[techIndex].times = newEntries[techIndex].times.filter((_, i) => i !== timeIndex);

      setTechnicianEntries(newEntries);

    }

  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
  };

  const uploadFiles = async (serviceReportId, files) => {
    if (!files || files.length === 0) return;

    if (!serviceReportId) {
      console.error('Service Report ID is undefined during file upload.');
      return;
    }

    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    try {
      const response = await axios.post(`${apiBaseUrl}/mnt/api/service-reports/${serviceReportId}/files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        console.log('Files uploaded successfully');
      } else {
        console.error('Error uploading files:', response.status);
      }
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  };



  const handleAddServiceReport = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/mnt/api/service-reports/init`);
      const { serviceReportId } = response.data;
      setTechnicianEntries([{ technician: '', times: [{ startTime: roundToNearest15(new Date()), endTime: roundToNearest15(new Date()), description: '', isNew: true }] }]);
      setEditId(serviceReportId);
      setShowForm(true);
      setShowContent(false);
    } catch (error) {
      console.error('Error initializing service report:', error);
    }
  };

  const handleCancel = () => {
    resetForm(); // Clear form fields properly 20250225
    setTemporaryFaults([]);
    setIsFromFault(false); // Reset fault source state
    setSelectedMachine(null); // Clear machine selection
    setSelectedFault('');
    setSelectedFaultId(null);
    setShowForm(false);
    setShowContent(true);
  };

  const handleRemoveFile = async (fileIndex) => {
    const fileToRemove = files[fileIndex];
    if (!fileToRemove) return;
  
    const userConfirmed = window.confirm(`Are you sure you want to delete the file: ${fileToRemove.filename}?`);
    let serviceReportId = editId;
    if (!userConfirmed) return;
  
    try {
														  
      await axios.delete(`${apiBaseUrl}/mnt/api/service-reports/${serviceReportId}/files/${fileToRemove.fileid}`, {
        data: { file: fileToRemove }
      });
  
      setFiles(files.filter((_, index) => index !== fileIndex));
      console.log('File removed successfully:', fileToRemove.filename);
    } catch (error) {
      console.error('Error removing file:', error);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
  
    if (!selectedMachine || !selectedFault || technicianEntries.some(entry => !entry.technician)) {
      setErrorMessage(t('ServiceReport.RequiredFieldsError'));
      window.scrollTo(0, 0);
      return;
    }
  
    let newFaultID = selectedFaultId;
  
																	 
    const tempFault = temporaryFaults.find(fault => fault.id === selectedFaultId);
    if (tempFault && !isEditing) {
      try {
        const response = await axios.post(`${apiBaseUrl}/mnt/api/fault-errors/add`, {
          machineid: selectedMachine.machineid,
          machine: selectedMachine.machine,
          description: tempFault.description,
          technician: technicianEntries[0].technician || '',
        });
  
        newFaultID = response.data.faultId;
        setTemporaryFaults([]);
      } catch (error) {
        console.error('Error adding fault:', error);
        setErrorMessage(t('ServiceReport.FaultAddError'));
        window.scrollTo(0, 0);
        return;
      }
    }
  
    const sanitizedMaterials = materials
      .map(material => ({
        quantity: String(material.quantity).trim() === '' ? '0' : String(material.quantity).trim(),
        description: material.description.trim(),
        price: String(material.price).trim() === '' ? '0' : String(material.price).trim(),
        unit: material.unit.trim(),
      }))
      .filter(material => !(material.quantity === '0' && material.price === '0' && material.description === '' && material.unit === ''));

  
    const sanitizedTechnicianEntries = technicianEntries.map(entry => ({
      ...entry,
      times: entry.times.map(time => ({
        ...time,
        startTime: formatDateTimeForDatabase(time.startTime),
        endTime: formatDateTimeForDatabase(time.endTime),
        hourly_rate: time.hourly_rate || hourlyRate,
        external: time.external,
      }))
    }));
  
    const isComplete = status === 'Closed';
    let updatedStatus = status;
  
    if (!isComplete) {
      if (isEditing && status === 'New') {
        updatedStatus = 'Open';
      }
    }
  
    const newReport = {
      machine: selectedMachine ? selectedMachine.machine : '',
      fault: selectedFault,
      descriptionAction,
      technicianEntries: sanitizedTechnicianEntries,
      materials: sanitizedMaterials,
      status: updatedStatus,
      faultID: newFaultID,
    };
  
    try {
      let serviceReportId = editId;
  
      if (isEditing) {
        await axios.patch(`${apiBaseUrl}/mnt/api/service-reports/${serviceReportId}`, newReport);
      } else {
        const response = await axios.post(`${apiBaseUrl}/mnt/api/service-reports`, newReport);
        serviceReportId = response.data.serviceReportId;
  
        if (!serviceReportId) {
          throw new Error('Service Report ID is undefined in the API response!');
        }
  
        setEditId(serviceReportId);
      }
  
      if (files.length > 0) {
        await uploadFiles(serviceReportId, files);
      }

      resetForm(); // Reset the form and close it
      setShowForm(false); // Ensure the form is closed after submission
      setShowContent(true);						   
    } catch (error) {
      console.error('Error saving service report:', error);
    }
  };


  const resetForm = () => {
    setSelectedMachine(null);
    setSelectedFault('');
    setDescriptionAction('');
    setTechnicianEntries([{ technician: '', times: [{startTime: roundToNearest15(new Date()), endTime: roundToNearest15(new Date()), description: '', isNew: true }] }]);
    setMaterials([{ quantity: '', description: '', price: '', unit: '' }]);
    setFiles([]);
    setTotalCost(0);
    setIsEditing(false);
    setEditId(null);
    setStatus('New');
    setEditableField(null);
    setShowForm(false);
    setShowContent(true);
  };
  
  useEffect(() => {
    return () => {
      resetForm(); // ✅ Clear form state on component unmount 20250225
    };
  }, []);
  

  const renderEditableField = (field, content, editContent) => {
    if (editableField === field) {
      return editContent;
    }else if(field !== 'fault'){
      return editContent;
    }

    return (
      <div class="entry-item entry-item__medium">
        <span>{content}</span>
        {isEditing && field !== 'machine' && field !== 'fault' && (
          <button type="button" className="sr-sr-btn btn-link" onClick={() => setEditableField(field)}>{t('ServiceReport.Edit')}</button>
        )}
      </div>
    );
  };

  const closeModal = () => {
    setReportToDelete(null);
    setModalIsOpen(false);
  };

  
  const handleDeleteReport = async (report) => {
    const userConfirmed = window.confirm(t('ServiceReport.ConfirmDeleteMessage'));
    
    if (userConfirmed) {
      try {
        await axios.delete(`${apiBaseUrl}/mnt/api/service-reports/${report.servicereportid}`);
        setServiceReports(serviceReports.filter(r => r.servicereportid !== report.servicereportid));
        console.log('Service report deleted successfully');
      } catch (error) {
        console.error('Error deleting service report:', error);
      }
    }
  };

  const handleFaultChange = (faultDescription) => {
    if (selectedFaultId) {
        alert(t('ServiceReport.FaultAlreadyAssignedError'));
        return;
    }

    const selectedFault = faults.find(fault => fault.description === faultDescription && fault.status === 'New');
    if (selectedFault) {
        setSelectedFault(faultDescription);
        setSelectedFaultId(selectedFault.id);
        handleTechnicianChange(0, selectedFault.technician);
    }
  };

  const handleClose = (type, index) => {
    console.log(type);
    // Remove the active class by clearing the active index
    if (type === "time") {
      setActiveTimeIndex(null);
    } else if (type === "material") {
      console.log("We got into the if statment");
      setActiveMaterialIndex("");
    }
    console.log(activeMaterialIndex);
    console.log(activeTimeIndex);
  };

  const roundToNearest15 = (date = new Date()) => {
    const rounded = new Date(date.getTime());
    const minutes = rounded.getMinutes();
    const remainder = minutes % 15;
    const minutesToAdd = remainder >= 8 ? (15 - remainder) : -remainder;
    rounded.setMinutes(minutes + minutesToAdd);
    rounded.setSeconds(0);
    rounded.setMilliseconds(0);
    console.log(rounded);
    return rounded;
  };

  // For table component
  const groupedReports = {
    [t('ServiceReport.IncompleteServiceReportsTitle')]: serviceReports.filter(r => r.status === 'New'),
    [t('ServiceReport.OpenServiceReportsTitle')]: serviceReports.filter(r => r.status === 'Open'),
  };
  
  const isFiltered =
    (selectedMachine && selectedMachine.machineid !== '') ||
    selectedMachineGroup !== '' ||
    selectedTechnician !== '';
  
  return (

    <div>

    {showFilters && (
      
      <div className="filter-container" onClick={() => setShowFilters(!showFilters)}>
        <div className="filter" onClick={(e) => e.stopPropagation()}>
          <div className="filter__fields">
            <div className="filter__label">{t('ServiceReport.Machine')}</div>
            <div className="entry-item">
                <MachineDropdown
                  value={selectedMachine ? selectedMachine.machineid : ''}
                  onSelectMachine={setSelectedMachine}
                  multiSelect={false}
                  required
                />
            </div>

            <div className="filter__label">{t('ServiceReport.MachineGroup')}</div>
            <div className="entry-item">
              <select
                id="machineGroup"
                className="form-select"
                value={selectedMachineGroup}
                onChange={(e) => setSelectedMachineGroup(e.target.value)}
              >
                <option value="">{t('ServiceReport.SelectMachineGroup')}</option>
                {machineGroups.map((group, index) => (
                  <option key={index} value={group}>
                    {group}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter__label">{t('ServiceReport.Technician')}</div>
            <div className="entry-item">
              {technicianEntries.map((entry, techIndex) => (
                <TechnicianDropdown
                  key={techIndex}
                  value={entry.technician}
                  onSelectTechnician={(technician) => handleTechnicianChangeFilter(techIndex, technician)}
                />
              ))}
            </div>
          
          </div>

          <div className="filter__buttons">
            <button type="button" className="button--grey" id="reset-filter">Reset</button> 
          </div>  

        </div>
      </div>

    )}

    {showForm && (
      
      <div className="modal-full">

        <form onSubmit={handleSubmit}>

        <div className="top-menu">
          <button type="submit" class="button--blue" id="save-report">{status === 'Closed' ? t('ServiceReport.SubmitReport') : isEditing ? t('ServiceReport.UpdateReport') :  t('ServiceReport.CreateReport')}</button>
          <div className="top-menu__button-space"></div>
          <button type="button" class="button--grey" onClick={handleCancel}>{t('ServiceReport.Cancel')}</button>
        </div>

        {isEditing ? (
          <div className="content__main-title">{t('ServiceReport.ServiceReportCurrent') + ' (' + editId + ')'}</div>
        ):(
          <div className="content__main-title">{t('ServiceReport.AddServiceReport')}</div>
        )}

        {errorMessage && (
          <div className="error-message" role="alert">
            {errorMessage}
          </div>
        )}

          <div class="form-section__title">{t('ServiceReport.MachineDetails')}</div>
          <div className="form-section">

            <div className="entry-item entry-item__content-width">
              <label className="entry-label">{selectedMachine ? selectedMachine.machine : ''}</label>
              {isFromFault || isEditing ? (
                <select hidden>
                  <option value="">{newFault.machine}</option>
                </select>
              ) : (
                <MachineDropdown
                  value={selectedMachine ? selectedMachine.machineid : ''}
                  onSelectMachine={setSelectedMachine}
                  multiSelect={false}
                  required
                />
              )}
            </div>

          </div>

          <div class="form-section__title">{t('ServiceReport.FaultErrorReport')}</div>
          <div className="form-section">
            
            {isFromFault || isEditing ? (
              renderEditableField(
                'fault',
                selectedFault,
                <div>
                  <div className="entry-item entry-item__content-width">
                    <label className="entry-label">{t('ServiceReport.ReportedFaultError')}</label>
                    <select
                      id="fault"
                      value={selectedFault}
                      onChange={(e) => handleFaultChange(e.target.value)}
                      
                    >
                      <option value="">{t('ServiceReport.SelectFaultError')}</option>
                      {faults
                        .filter(fault => fault.status === 'New' || fault.id === editId)
                        .map((fault, index) => (
                          <option key={index} value={fault.description}>{fault.description}</option>
                        ))}
                    </select>
                  </div>
                  <div class="entry-item entry-item__medium">
                    <input
                      type="text"
                      placeholder={t('ServiceReport.AddNewFaultError')}
                      value={newFault}
                      onChange={(e) => setNewFault(e.target.value)}
                    />
                  </div>
                  <div class="entry-item entry-item__medium">
                    <button
                      type="button"
                      className="button--icon-add button--grey"
                      onClick={handleAddFault}
                      disabled={!newFault}
                    ><AddIcon /> {t('ServiceReport.AddError')}</button>
                  </div>
                </div>
              )
            ) : (
              <div>
                <div className="entry-item entry-item__content-width">
                  <label className="entry-label">{t('ServiceReport.ReportedFaultError')}</label>
                  <select
                    id="fault"
                    value={selectedFault}
                    onChange={(e) => handleFaultChange(e.target.value)}
                    
                  >
                    <option value="">{t('ServiceReport.SelectFaultError')}</option>
                    {faults
                      .filter(fault => fault.status === 'New' || fault.id === editId)
                      .map((fault, index) => (
                        <option key={index} value={fault.description}>{fault.description}</option>
                      ))}
                  </select>
                </div>
                <div class="entry-item entry-item__medium">
                  <input
                    type="text"
                    placeholder={t('ServiceReport.AddNewFaultError')}
                    value={newFault}
                    onChange={(e) => setNewFault(e.target.value)}
                  />
                </div>
                <div class="entry-item entry-item__medium">
                  <button
                    type="button"
                    className="button--icon-add button--grey"
                    onClick={handleAddFault}
                    disabled={!newFault}
                  ><AddIcon /> {t('ServiceReport.AddError')}</button>
                </div>
              </div>
            )}

          </div>
          <div className="form-section__title">{t('ServiceReport.faultFiles')}</div>
            <div className="file-section">
              <div className="file-list">
                {faultFiles.map((file, index) => (
                  <div key={file.filename || index} className="entry-item__file">
                    <a
                  href={
                    file.filepath
                      ? `${apiBaseUrl}/mnt/api/uploads/report/${file.filename.replace(/\\/g, '/')}`
                      : '#'
                  }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {file.filename || file.name}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          <div class="form-section__title">{t('ServiceReport.WorkDescription')}</div>
          <div class="form-section">
            <div class="entry-item entry-item__full-width">
              {isEditing ? (

                  <textarea
                    id="descriptionAction"
                    className=""
                    maxLength="2000"
                    placeholder= {t('ServiceReport.DescriptionOfWork')}
                    value={descriptionAction}
                    onChange={(e) => setDescriptionAction(e.target.value)}
                  />
               
              ) : (
                <textarea
                  id="descriptionAction"
                  className=""
                  maxLength="2000"
                  placeholder={t('ServiceReport.DescriptionOfWork')}
                  value={descriptionAction}
                  onChange={(e) => setDescriptionAction(e.target.value)}
                />
              )}

            </div>
          </div>

          <div class="form-section__title">{t('ServiceReport.TechniciansTimeRegistration')}</div>
           
          {technicianEntries.map((entry, techIndex) => (
            <div key={`${entry.technician}-${techIndex}`} class="form-section">

            <div className=""> 
              {(entry.technician !== '' && isFromFault) || isEditing ? (

                  <div class="entry-item entry-item__content-width">
                    <TechnicianDropdown
                      onSelectTechnician={(value) => handleTechnicianChange(techIndex, value)}
                      value={entry.technician}
                      required
                    />
          {technicianEntries.length > 1 && (
            <button 
              type="button" 
              className="button--icon-add button--grey"
              onClick={() => handleRemoveTechnician(techIndex)}
            >
              {t('ServiceReport.Remove')}
            </button>
          )}
                  </div>
                
              ) : (
                <div class="entry-item entry-item__content-width">
                  <TechnicianDropdown
                    onSelectTechnician={(value) => handleTechnicianChange(techIndex, value)}
                    value={entry.technician}
                    required
                  />
          {technicianEntries.length > 1 && (
            <button 
              type="button" 
              className="button--icon-add button--grey"
              onClick={() => handleRemoveTechnician(techIndex)}
            >
              {t('ServiceReport.Remove')}
            </button>
          )}
                </div>
              )}


              <div class="entry-list">

                {entry.times.map((time, timeIndex) => (

                  <React.Fragment key={`${time.startTime}-${timeIndex}`}>

                    {isEditing && !time.isNew ? (
                      renderEditableField(
                        `time-${techIndex}-${timeIndex}`,
                        `${formatDateByLocale(time.startTime / 1000, i18n.language)} - ${formatDateByLocale(time.endTime / 1000, i18n.language)} (${time.description})`,                        
                        <div
                          className={`entry-item entry-item--mobile-button ${
                           activeTimeIndex === timeIndex ? "entry-item--active" : ""
                          }`}
                          onClick={() => setActiveTimeIndex(timeIndex)}
                        >
                          <div class="entry-item__details"> 

                          <div className="entry-field__time-date-from">
                            <label className="entry-label">{t('ServiceReport.TimeFrom')}</label>
                            <DatePicker
                                selected={
                                  // If we have a startTime, round that.
                                  // Otherwise, round “now”.
                                  time.startTime && !isNaN(time.startTime)
                                    ? roundToNearest15(new Date(time.startTime))
                                    : roundToNearest15()
                                }
                              onChange={(date) => handleTimeEntryChange(techIndex, timeIndex, 'startTime', date)}
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeIntervals={15}
                              dateFormat={formatDateByLocale(Math.floor(time.startTime / 1000), i18n.language)} // Use formatDateByLocale for the format
                              className="form-datepicker"
                              maxDate={time.endTime && !isNaN(time.endTime) ? new Date(time.endTime) : null}
                            />
                          </div>

                          <div className="entry-field__time-date-to">
                            <label className="entry-label">{t('ServiceReport.TimeTo')}</label>
                            <DatePicker
                                selected={
                                  time.endTime && !isNaN(time.endTime)
                                  ? roundToNearest15(new Date(time.endTime))
                                  : roundToNearest15()
                                }
                              onChange={(date) => handleTimeEntryChange(techIndex, timeIndex, 'endTime', date)}
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeIntervals={15}
                              dateFormat={formatDateByLocale(Math.floor(time.endTime / 1000), i18n.language)} // Use formatDateByLocale for the format
                              className="form-datepicker"
                              minDate={time.startTime && !isNaN(time.startTime) ? new Date(time.startTime) : null}
                            />
                          </div>

                            <div class="entry-field__time-description">
                              <label class="entry-label">{t('ServiceReport.TimeWorkDescription')}</label>
                              <input
                                type="text"
                                className=""
                                value={time.description}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'description', e.target.value)}
                                placeholder={t('ServiceReport.Description')}
                              />
                            </div>

                            <div class="entry-field__time-rate">
                              <label class="entry-label">{t('ServiceReport.TimeHourlyRate')}</label>
                              <input
                                type="number"
                                className=""
                                value={time.hourly_rate}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'hourly_rate', e.target.value)}
                                disabled={!time.external}
                                placeholder={t('ServiceReport.HourlyRate')}
                              />
                            </div>

                            <div class="entry-field__time-rate-btn">
                              <label class="entry-label">&nbsp;</label>
                              <input
                                type="checkbox"
                                className="sr-sr-form-check-input"
                                id={`external-${techIndex}-${timeIndex}`}
                                checked={time.external}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'external', e.target.checked)}
                              />
                            </div>
                            
                            <div class="entry-item__actions">
                              <div class="entry-actions__ok-btn"><label class="entry-label">&nbsp;</label><button class="button--blue" type="button" onClick={() => handleClose("time", timeIndex)}>{t('ServiceReport.ButtonOkClose')}</button></div>
                              <div class="entry-actions__delete-btn">
                                <label class="entry-label">&nbsp;</label>
                                {technicianEntries[techIndex].times.length > 1 && (
                                  <button
                                    className="slim-button--remove"
                                    type="button"
                                    onClick={() => handleRemoveTimeEntry(techIndex, timeIndex)}
                                  >
                                    <RemoveItemIcon />
                                  </button>
                                )}
                              </div>
                            </div>                             

                          </div>
                          <div class="entry-item--collapsed">  
                            <div class="entry-item__summary-description">{t('ServiceReport.Description')}</div>
                            <div class="entry-item__summary-left">Date Starttime - Endtime</div>
                            <div class="entry-item__summary-right">{time.hourly_rate}</div>
                          </div>    
                        </div>
                      )
                   
                    ) : (

                      <div
                        key={timeIndex}                      
                        className={`entry-item entry-item--mobile-button ${
                          activeTimeIndex === timeIndex ? "entry-item--active" : ""
                        }`}
                        onClick={() => {
                          // Only set active if it's NOT already the active one
                          if (activeTimeIndex !== timeIndex) {
                            setActiveTimeIndex(timeIndex);
                          }
                        }}
                      >
                          <div class="entry-item__details"> 
                      
                          {time.isNew ? (
                            <>

                            <div className="entry-field__time-date-from">
                              <label className="entry-label">From</label>
                              <DatePicker
                                  selected={
                                    // If we have a startTime, round that.
                                    // Otherwise, round “now”.
                                    time.startTime && !isNaN(time.startTime)
                                      ? roundToNearest15(new Date(time.startTime))
                                      : roundToNearest15()
                                  }
                                onChange={(date) => handleTimeEntryChange(techIndex, timeIndex, 'startTime', date)}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat={formatDateByLocale(Math.floor(time.startTime / 1000), i18n.language)} // Use formatDateByLocale for the format
                                className="form-datepicker"
                                maxDate={time.endTime && !isNaN(time.endTime) ? new Date(time.endTime) : null}
                              />
                            </div>

                            <div className="entry-field__time-date-to">
                              <label className="entry-label">To</label>
                              <DatePicker
                              selected={
                                // If we have a startTime, round that.
                                // Otherwise, round “now”.
                                time.endTime && !isNaN(time.sendTime)
                                  ? roundToNearest15(new Date(time.endTime))
                                  : roundToNearest15()
                              }
                                onChange={(date) => handleTimeEntryChange(techIndex, timeIndex, 'endTime', date)}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat={formatDateByLocale(Math.floor(time.endTime / 1000), i18n.language)} // Use formatDateByLocale for the format
                                className="form-datepicker"
                                minDate={time.startTime && !isNaN(time.startTime) ? new Date(time.startTime) : null}
                              />
                            </div>

                            <div class="entry-field__time-description">
                              <label class="entry-label">{t('ServiceReport.TimeWorkDescription')}</label>
                              <input
                                type="text"
                                className=""
                                value={time.description}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'description', e.target.value)}
                                placeholder={t('ServiceReport.Description')}
                              />
                            </div>

                            <div class="entry-field__time-rate">
                              <label class="entry-label">{t('ServiceReport.TimeHourlyRate')}</label>
                              <input
                                type="number"
                                className=""
                                value={time.hourly_rate}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'hourly_rate', e.target.value)}
                                disabled={!time.external}
                                placeholder={t('ServiceReport.HourlyRate')}
                              />
                            </div>

                            <div class="entry-field__time-rate-btn">
                              <label class="entry-label">&nbsp;</label>
                              <input
                                type="checkbox"
                                className="sr-sr-form-check-input"
                                id={`external-${techIndex}-${timeIndex}`}
                                checked={time.external}
                                onChange={(e) => handleTimeEntryChange(techIndex, timeIndex, 'external', e.target.checked)}
                              />
                            </div>
                            
                            <div class="entry-item__actions">
                              <div class="entry-actions__ok-btn"><label class="entry-label">&nbsp;</label><button class="button--blue" type="button" onClick={() => handleClose("time", timeIndex)}>OK / Close</button></div>
                              <div class="entry-actions__delete-btn">
                                <label class="entry-label">&nbsp;</label>
                                
                                {technicianEntries[techIndex].times.length > 1 && (
                                <button
                                  className="slim-button--remove"
                                  type="button"
                                  onClick={() => handleRemoveTimeEntry(techIndex, timeIndex)}
                                >
                                  <RemoveItemIcon />
                                </button>
                              )}
                              </div>
                            </div>      


                            </>
                          ) : (
                            <>
                              <div className="sr-sr-d-flex align-items-center">
                              <span className="sr-sr-me-2">{formatDateByLocale(time.startTime / 1000, i18n.language)}</span>
                              <span className="sr-sr-me-2">{formatDateByLocale(time.endTime / 1000, i18n.language)}</span>
                                <span className="sr-sr-me-2">{time.description}</span>
                                <span className="sr-sr-me-2">{time.hourly_rate}</span>
                                <span className="sr-sr-me-2">{time.external ? t('ServiceReport.External') : t('ServiceReport.Internal')}</span>
                              </div>

                            </>
                          )}

                        </div>
                        <div class="entry-item--collapsed">  
                          <div class="entry-item__summary-description">{t('ServiceReport.Description')}</div>
                          <div class="entry-item__summary-left">Date Starttime - Endtime</div>
                          <div class="entry-item__summary-right">{time.hourly_rate}</div>
                        </div>   
                      </div>
                    )}
                  </React.Fragment>
                ))}

                <button type="button" className="button--icon button--grey" onClick={() => handleAddTimeEntry(techIndex)}>
                  <AddIcon />
                </button>

              </div>

            </div>
            </div>

          ))}

          <div class="entry-item">
            <button type="button" class="button--icon-add button--grey" onClick={handleAddTechnician}><AddIcon /> {t('ServiceReport.Technician')}</button>
          </div>
          

          <div class="form-section__title">{t('ServiceReport.Materials')}</div>
          <div class="form-section">
            <div class="entry-list">

              {materials.map((material, index) => {
                const totalCost = material.quantity * material.price;
                return (
                  
                  <div
                  key={index}
                  className={`entry-item entry-item--mobile-button ${
                    activeMaterialIndex === index ? "entry-item--active" : ""
                  }`}
                  onClick={() => {
                    // Only set active if it's NOT already the active one
                    if (activeMaterialIndex !== index) {
                      setActiveMaterialIndex(index);
                    }
                  }}
                >
                  <div class="entry-item__details">

                    {isEditing ? (
                      renderEditableField(
                        `material-${index}`,
                        `${material.quantity} ${material.unit} x ${material.description} ${t('ServiceReport.PricePerUnit')} 
                        ${currencyPosition === 'left' ? `${currencySymbol}${material.price}` : `${material.price}${currencySymbol}`}`,

                        <> 

                          <div class="entry-field__material-description">
                            <label class="entry-label">{t('ServiceReport.MaterialMaterial')}</label>
                            <input
                              type="text"
                              className="entry-control"
                              value={material.description}
                              onChange={(e) => handleMaterialChange(index, 'description', e.target.value)}
                              placeholder={t('ServiceReport.Description')}
                            />
                          </div>

                          <div class="entry-field__material-qty">
                            <label class="entry-label">{t('ServiceReport.MaterialQTY')}</label>
                            <input
                              type="number"
                              className="entry-control"
                              value={material.quantity}
                              onChange={(e) => handleMaterialChange(index, 'quantity', e.target.value)}
                              placeholder={t('ServiceReport.Quantity')}
                            />
                          </div>

                          <div class="entry-field__material-unit">
                            <label class="entry-label">{t('ServiceReport.MaterialUnit')}</label>
                            <select
                              className="entry-control form-select"
                              value={material.unit}
                              onChange={(e) => handleMaterialChange(index, 'unit', e.target.value)}
                            >
                              <option value="">{t('ServiceReport.ChooseUnit')}</option>
                              <option value="pcs">{t('ServiceReport.Pcs')}</option>
                              <option value="set">{t('ServiceReport.Set')}</option>
                              <option value="hr">{t('ServiceReport.Hour')}</option>
                              <option value="day">{t('ServiceReport.Day')}</option>
                              <option value="km">{t('ServiceReport.Kilometer')}</option>
                              <option value="mile">{t('ServiceReport.Mile')}</option>
                              <option value="in">{t('ServiceReport.Inch')}</option>
                              <option value="ft">{t('ServiceReport.Feet')}</option>
                              <option value="yd">{t('ServiceReport.Yard')}</option>
                              <option value="meter">{t('ServiceReport.Meter')}</option>
                              <option value="cm">{t('ServiceReport.Cm')}</option>
                              <option value="mm">{t('ServiceReport.Mm')}</option>
                              <option value="l">{t('ServiceReport.Liter')}</option>
                              <option value="cl">{t('ServiceReport.Centiliter')}</option>
                              <option value="ml">{t('ServiceReport.Milliliter')}</option>
                              <option value="gallon">{t('ServiceReport.Gallon')}</option>
                              <option value="kg">{t('ServiceReport.Kg')}</option>
                              <option value="g">{t('ServiceReport.Gram')}</option>
                              <option value="oz">{t('ServiceReport.Ounce')}</option>
                              <option value="lb">{t('ServiceReport.Pound')}</option>
                              <option value="ton">{t('ServiceReport.Ton')}</option>
                            </select>
                          </div>

                          <div class="entry-field__material-unit-price">
                            <label class="entry-label">{t('ServiceReport.MaterialUnitPrice')}</label>
                            <input
                              type="number"
                              className="entry-control"
                              value={material.price}
                              onChange={(e) => handleMaterialChange(index, 'price', e.target.value)}
                              placeholder={t('ServiceReport.Price')}
                            />
                          </div>

                          <div class="entry-field__material-total-price">
                            <label class="entry-label">{t('ServiceReport.MaterialTotal')}</label>
                            {currencyPosition === 'left' ? (
                              <input className="entry-control" type="text" readOnly value={`${currencySymbol}${totalCost.toFixed(2)}`} />
                            ) : (
                              <input className="entry-control" type="text" readOnly value={`${totalCost.toFixed(2)}${currencySymbol}`} />
                            )}
                          </div>

                          <div class="entry-item__actions">
                            <div class="entry-actions__ok-btn"><label class="entry-label">&nbsp;</label><button class="button--blue" onClick={() => handleClose("material", index)}>OK / Close</button></div>
                            {materials.length > 1 && (
                              <div class="entry-actions__delete-btn"><label class="entry-label">&nbsp;</label><button class="slim-button--remove" type="button" onClick={() => handleRemoveMaterial(index)}><RemoveItemIcon /></button></div>
                            )}
                            
                          </div>  
                        
                        </>
                      )
                    ) : (
                      
                      <>

                        <div class="entry-field__material-description">
                          <label class="entry-label">{t('ServiceReport.MaterialMaterial')}</label>
                          <input
                            type="text"
                            className="entry-control"
                            value={material.description}
                            onChange={(e) => handleMaterialChange(index, 'description', e.target.value)}
                            placeholder={t('ServiceReport.Description')}
                          />
                        </div>

                        <div class="entry-field__material-qty">
                          <label class="entry-label">{t('ServiceReport.MaterialQTY')}</label>
                          <input
                            type="number"
                            className="entry-control"
                            value={material.quantity}
                            onChange={(e) => handleMaterialChange(index, 'quantity', e.target.value)}
                            placeholder={t('ServiceReport.Quantity')}
                          />
                        </div>

                        <div class="entry-field__material-unit">
                          <label class="entry-label">{t('ServiceReport.MaterialUnit')}</label>
                          <select
                            className="entry-control"
                            value={material.unit}
                            onChange={(e) => handleMaterialChange(index, 'unit', e.target.value)}
                          >
                            <option value="">{t('ServiceReport.ChooseUnit')}</option>
                            <option value="pcs">{t('ServiceReport.Pcs')}</option>
                            <option value="set">{t('ServiceReport.Set')}</option>
                            <option value="hr">{t('ServiceReport.Hour')}</option>
                            <option value="day">{t('ServiceReport.Day')}</option>
                            <option value="km">{t('ServiceReport.Kilometer')}</option>
                            <option value="mile">{t('ServiceReport.Mile')}</option>
                            <option value="in">{t('ServiceReport.Inch')}</option>
                            <option value="ft">{t('ServiceReport.Feet')}</option>
                            <option value="yd">{t('ServiceReport.Yard')}</option>
                            <option value="meter">{t('ServiceReport.Meter')}</option>
                            <option value="cm">{t('ServiceReport.Cm')}</option>
                            <option value="mm">{t('ServiceReport.Mm')}</option>
                            <option value="l">{t('ServiceReport.Liter')}</option>
                            <option value="cl">{t('ServiceReport.Centiliter')}</option>
                            <option value="ml">{t('ServiceReport.Milliliter')}</option>
                            <option value="gallon">{t('ServiceReport.Gallon')}</option>
                            <option value="kg">{t('ServiceReport.Kg')}</option>
                            <option value="g">{t('ServiceReport.Gram')}</option>
                            <option value="oz">{t('ServiceReport.Ounce')}</option>
                            <option value="lb">{t('ServiceReport.Pound')}</option>
                            <option value="ton">{t('ServiceReport.Ton')}</option>
                          </select>
                        </div>

                        <div class="entry-field__material-unit-price">
                          <label class="entry-label">{t('ServiceReport.MaterialUnitPrice')}</label>
                          <input
                            type="number"
                            className="entry-control"
                            value={material.price}
                            onChange={(e) => handleMaterialChange(index, 'price', e.target.value)}
                            placeholder={t('ServiceReport.Price')}
                          />
                        </div>

                        <div class="entry-field__material-total-price">
                          <label class="entry-label">{t('ServiceReport.MaterialTotal')}</label>
                        
                          {currencyPosition === 'left' ? (
                            <input class="entry-control" type="text" placeholder="" value={`${currencySymbol}${totalCost.toFixed(2)}`} tabindex="-1" />
                          ) : (
                            <input class="entry-control" type="text" placeholder="" value={`${totalCost.toFixed(2)}${currencySymbol}`} tabindex="-1" />
                          )}

                        </div>

                        <div class="entry-item__actions">
                          <div class="entry-actions__ok-btn"><label class="entry-label">&nbsp;</label><button class="button--blue" type="button" onClick={() => handleClose("material", index)}>OK / Close</button></div>
                          {materials.length > 1 && (
                              <div class="entry-actions__delete-btn"><label class="entry-label">&nbsp;</label><button class="slim-button--remove" type="button" onClick={() => handleRemoveMaterial(index)}><RemoveItemIcon /></button></div>
                            )}
                        </div>  

                      </>
                    )}
                  
                  </div>
                  <div class="entry-item--collapsed">  
                    <div class="entry-item__summary-description">{t('ServiceReport.MaterialCollapseDescription')}</div>
                    <div class="entry-item__summary-left">&nbsp</div>
                    <div class="entry-item__summary-right">&nbsp</div>
                  </div>  
                </div>

                );
              })}

            </div>

            <div className="entry-item">
              <div className="form-entry__total-cost">
                {t('ServiceReport.TotalCost')}:&nbsp; 
                {currencyPosition === 'left' 
                  ? `${currencySymbol} ${totalCost.toFixed(2)}` 
                  : `${totalCost.toFixed(2)} ${currencySymbol}`}
              </div>
            </div>

            <div className="entry-item">
              <button type="button" className="button--icon button--grey" onClick={handleAddMaterial}><AddIcon /></button>
            </div>

          </div>

          <div className="form-section__title">{t('ServiceReport.UploadFiles')}</div>
          <div 
            className={`form-section ${dragOver ? 'form-section--drag-over' : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className="file-list">

              {files.map((file, index) => (

                <a
                  key={file.fileid ? `${file.fileid}-${index}` : index}
                  href={
                    file.filepath
                      ? `${apiBaseUrl}/mnt/api/uploads/report/${file.filepath.replace(/\\/g, '/').replace('/uploads/reports/', '')}`
                      : '#'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  class="entry-item__file"
                >
                  <div className="entry-item__file-icon"><FileIcon /></div>
                  {file.filename || file.name}
                  <button 
                    className="slim-button--remove"
                    type="button"
                    onClick={() => handleRemoveFile(index)}
                  ><RemoveItemIcon /></button>
                </a>

              ))}

            </div>

            <div className="file-upload">
              <input 
                type="file" 
                class="file-upload__input" 
                id="files" 
                multiple
                onChange={handleFileChange}
              />
              <label htmlFor="files" className="file-upload__label">
                <button type="button" className="button--icon button--grey" onClick={() => document.getElementById('files').click()}><AddIcon /></button>
              </label>
            </div>
            


          </div>

          <div class="form-section__title">
            Status
          </div>
          <div class="form-section--report-completion">
            <div class="checkbox-container">
              <input
                type="checkbox"
                className="checkbox-input"
                id="completeStatus"
                checked={status === 'Closed'}
                onChange={(e) => {
                  if (e.target.checked) {
                    const userConfirmed = window.confirm(t('ServiceReport.CompleteStatusConfirm'));
                    if (userConfirmed) {
                      setStatus('Closed');
                    } else {
                      e.target.checked = false;
                    }
                  } else {
                    setStatus('Open');
                  }
                }}
              />
              <label htmlFor="completeStatus" class="checkbox-label">{t('ServiceReport.ServiceReportStatus')}</label>
            </div>
            <p class="checkbox-description">
              {t('ServiceReport.CompleteReportLock')}
            </p>
          </div>

          <div class="form-submit">
            <button type="submit" class="button--blue" id="save-report">{status === 'Closed' ? t('ServiceReport.SubmitReport') : isEditing ? t('ServiceReport.UpdateReport') :  t('ServiceReport.CreateReport')}</button>
            <div class="top-menu__button-space"></div>
            <button type="button" class="button--grey" onClick={handleCancel}>{t('ServiceReport.Cancel')}</button>
          </div>

        </form>
      </div>

    )}

    {showContent && (

      <div className="content">

        <div className="top-menu">
          <div className="top-menu__divider"></div>
          <div className="top-menu__icon-button top-menu__filter-button" onClick={() => setShowFilters(!showFilters)}><FilterIcon /></div>
          {permissions.can_edit && (
            <button type="button" className="button--icon-add button--green" 
               onClick={handleAddServiceReport}>
               <AddIcon /> {t('ServiceReport.AddReport')}</button>
          )}  
        </div>

        <div className="content__main-title">{t('ServiceReport.Title')}</div>

        <GroupedDataTable
          groupedData={groupedReports}
          isFiltered = {isFiltered}
          headers={[
            {
              label: t("detailedServiceReport.tableHeaders.description"),
              accessor: "fault",
              elasticCell: true,
              colorStyle: "block",
              colorValueFrom: (r) => r.status === "New" ? "green" : "blue",
            },
            /*
            {
              label: t("ServiceReport.headers.status"),
              accessor: "status",
              hideMobile: true,
            },
            */
            {
              label: t("timeReports.machine"),
              accessor: "machine",
              hideMobile: true,
            },
            {
              label: t("detailedServiceReport.tableHeaders.date"),
              render: (r) =>
                formatDateByLocale(Math.floor(r.updated_at / 1000), i18n.language),
              hideMobile: true,
            },
            {
              label: t("detailedServiceReport.reportId"),
              accessor: "servicereportid",
              hideMobile: true,
            },
          ]}
          /*{
          groupTitleFn={(title) => title}
          emptyGroupContentFn={(groupKey) =>
            groupKey === t("ServiceReport.NewReportsTitle")
              ? t("ServiceReport.NoNewReports")
              : groupKey === t("ServiceReport.OpenServiceReportsTitle")
              ? t("ServiceReport.NoOpenReports")
              : null
          }
          }*/
          groupMeta={{
            [t("ServiceReport.IncompleteServiceReportsTitle")]: {
              description: t("ServiceReport.TitleDescriptionpartially"),
              emptyMessage: t("ServiceReport.NoNewReports"),
            },
            [t("ServiceReport.OpenServiceReportsTitle")]: {
              description: t('ServiceReport.TitleDescriptionOpensr'),
              emptyMessage: t("ServiceReport.NoOpenReports"),
            },
          }} 
          rowKeyFn={(r) => r.servicereportid}
          onPrimaryAction={(r) => handleEditReport(r)}
          getPrimaryActionLabel={(r) =>
            r.status === "New"
              ? t("ServiceReport.buttonstartservicereport")
              : t("ServiceReport.buttonservicereport")
          }
          contextualOptionsFn={(r) =>
            (permissions.can_delete || permissions.can_edit) ? [
              {
                label: t("FaultError.buttons.delete"),
                onClick: (e) => {
                  e.preventDefault();
                  handleDeleteReport(r);
                },
              },
            ] : []
          }
        />


      </div>

    )}


      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel={t('ServiceReport.DeleteConfirmation')}
      >
        <h2>{t('ServiceReport.ConfirmDelete')}</h2>
        <p>{t('ServiceReport.DeleteServiceReportConfirmMessage')}</p>
        <button className="sr-sr-btn btn-danger" onClick={handleDeleteReport}>{t('ServiceReport.YesDelete')}</button>
        <button className="sr-sr-btn btn-secondary" onClick={closeModal}>{t('ServiceReport.Cancel')}</button>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCancelDelete}
        contentLabel={t('ServiceReport.ConfirmDelete')}
        className="sr-sr-Modal"
        overlayclassName="sr-sr-Overlay"
      >
        <h2>{t('ServiceReport.TimeEntryDelete')}</h2>
        <p>{t('ServiceReport.TimeEntryDeleteMessage')}</p>
        <div>
          <button className="sr-sr-btn btn-danger" onClick={handleRemoveTimeEntry}>{t('ServiceReport.Yes')}</button>
          <button className="sr-sr-btn btn-secondary" onClick={handleCancelDelete}>{t('ServiceReport.No')}</button>
        </div>
      </Modal>

    </div>

  );

};

export default ServiceReport;
